import { useCallback, useMemo, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { FormattedMessage } from "react-intl";
import { Row, Col, Divider } from "antd";

import Navigation from "./navigation";
import config from "../../../../config";
import CheckboxInfo from "../checkboxInfo";

import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

import "./index.css";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/js/pdf.worker.min.js`;

const TermsAndConditions = ({
  termsHasError,
  formItemLayout,
  onTermsAgreeChange,
  onSetTermsHasError,
}) => {
  const path = useMemo(() => config.TERMS_DOCUMENT_URL_LOCAL, []);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
  }, []);
  const handlePageChange = useCallback((offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }, []);

  const [showPagination, setShowPagination] = useState();
  const handleShowNagination = useCallback(() => {
    setShowPagination(true);
  }, []);
  const handleHideNagination = useCallback(() => {
    setShowPagination(false);
  }, []);

  return (
    <>
      <Row justify="center">
        <Col>
          <div
            onMouseEnter={handleShowNagination}
            onMouseLeave={handleHideNagination}
          >
            <Document file={path} onLoadSuccess={onDocumentLoadSuccess}>
              <Navigation
                top
                numPages={numPages}
                show={showPagination}
                pageNumber={pageNumber}
                onPageChange={handlePageChange}
              />
              <Page pageNumber={pageNumber} />
              {Array.from(new Array(numPages), (_el, index) => (
                <Page
                  pageNumber={index + 1}
                  key={`page_${index + 1}`}
                  className="pdf-hidden-page"
                />
              ))}
              <Navigation
                numPages={numPages}
                show={showPagination}
                pageNumber={pageNumber}
                onPageChange={handlePageChange}
              />
            </Document>
          </div>
        </Col>
      </Row>
      <Divider />
      <a
        target="_blank"
        rel="noreferrer noopener"
        href={config.TERMS_DOCUMENT_URL}
      >
        <FormattedMessage
          id="registration.terms.here"
          defaultMessage="aktuální obchodní podmínky pro tisk"
        />
      </a>
      <CheckboxInfo
        hasError={termsHasError}
        className="terms-checkbox"
        labelId="registration.terms"
        fieldName="termsAndConditions"
        formItemLayout={formItemLayout}
        onAgreeChange={onTermsAgreeChange}
        onSetHasError={onSetTermsHasError}
        messageId="registration.terms.mustHave"
        messageDefaultMessage="Musíte souhlasit s obchodními podmínkami."
        labelDefaultMessage="Potvrzuji, že jsem přečetl obchodní podmínky a plně s nimi souhlasím."
      />
    </>
  );
};

export default TermsAndConditions;
